import { atom, selector } from 'recoil';
import {
  designationApproverInitialState,
  getApprovalEntityActions,
  getDesignationApprovers,
  getEntityDetails,
} from './apiHelpers';

export const designationApproversTrigger = atom({
  key: 'admin/designationApproversTrigger',
  default: 0,
});

export const fetchDesignationApprovers = selector({
  key: 'admin/fetchDesignationApprovers',
  get: async ({ get }) => {
    const trigger = get(designationApproversTrigger);
    if (!trigger) return designationApproverInitialState;
    return getDesignationApprovers();
  },
});

export const entityDetailsParamsAtom = atom({
  key: 'admin/entityDetailsParamsAtom',
  default: { entityId: '' },
});

export const getEntityDetailsSelector = selector({
  key: 'admin/getEntityDetailsSelector',
  get: async ({ get }) => {
    const { entityId } = get(entityDetailsParamsAtom);
    return getEntityDetails(entityId);
  },
});

export const getEntityActionsSelector = selector({
  key: 'admin/getEntityActionsSelector',
  get: async ({ get }) => {
    const { entityId } = get(entityDetailsParamsAtom);
    return getApprovalEntityActions(+entityId);
  },
});
